import { useEffect, useState } from 'react';

type DeviceType = 'iOS' | 'Android' | 'Other';

export function useDevice() {
  const [platform, setPlatform] = useState<DeviceType>('Android');

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (
      userAgent.includes('iphone') ||
      userAgent.includes('ipod') ||
      userAgent.includes('ipad')
    ) {
      setPlatform('iOS');
    } else if (userAgent.includes('android')) {
      setPlatform('Android');
    } else {
      setPlatform('Other');
    }
  }, []);

  return platform;
}
